import { useEffect, useState } from 'react';

export default function ScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > window.innerHeight * 0.8);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      onClick={scrollToTop}
      aria-label="回到页面顶部"
      className="interactive fixed transition-all duration-500 hover:scale-110"
      style={{
        left: '24px',
        bottom: visible ? '32px' : '-60px',
        opacity: visible ? 1 : 0,
        width: '44px',
        height: '44px',
        borderRadius: '50%',
        backgroundColor: 'rgba(21, 20, 20, 0.7)',
        backdropFilter: 'blur(8px)',
        border: '1px solid rgba(252, 252, 252, 0.1)',
        color: '#fcfcfc',
        cursor: 'pointer',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M12 19V5M5 12l7-7 7 7" />
      </svg>
    </button>
  );
}
